import { withHandlers } from "reassemble";
import matchTransitionProperty from "../utils/matchTransitionProperty";
export var withTransitionObserver = withHandlers({
  onTransitionStart: function onTransitionStart(_a) {
    var firstProperty = _a.transitionInfo.firstProperty,
      inTransition = _a.transitionState.inTransition,
      onTransitionStart = _a.onTransitionStart,
      onTransitionBegin = _a.onTransitionBegin;
    return function (e) {
      if (onTransitionStart) {
        onTransitionStart(e);
      }
      if (!inTransition || e.target !== e.currentTarget || !matchTransitionProperty(e.propertyName, firstProperty)) {
        return;
      }
      onTransitionBegin();
    };
  },
  onTransitionEnd: function onTransitionEnd(_a) {
    var lastProperty = _a.transitionInfo.lastProperty,
      inTransition = _a.transitionState.inTransition,
      onTransitionEnd = _a.onTransitionEnd,
      onTransitionComplete = _a.onTransitionComplete;
    return function (e) {
      if (onTransitionEnd) {
        onTransitionEnd(e);
      }
      if (!inTransition || e.target !== e.currentTarget || !matchTransitionProperty(e.propertyName, lastProperty)) {
        return;
      }
      onTransitionComplete();
    };
  }
});